import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state: {
        processorList: [],
        totalCount: 0,
        coinType: ""
    },
    getters: {},
    mutations: {
        setProcessorList(state, payload) {
            state.processorList = payload;
        },
        setTotalCount(state, payload) {
            state.totalCount = payload;
        },
        setCoinType(state, payload) {
            state.coinType = payload;
        },
    },
    actions: {
        list({ commit }, coin) {
            commit('setCoinType', coin.code);
            api.getProcessorList(coin).then(({ data }) => {
                commit('setProcessorList', data.list);
                commit('setTotalCount', data.totalCount);
            });
        },
        updatePendingHeight(context, data) {
            return api.updatePendingHeight(data);
        },
        updateConfimedHeight(context, data) {
            return api.updateConfimedHeight(data);
        }
    }
};

appStore.registerModule('processorConfigSetting', store);